var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { getTreatment } from '../../clearstep/util/Split';
import { getTriageSummaryReason } from '../../../api/ConversationResults';
import i18n from '../../../util/i18n/config';
// Split name 'show_why_this_result' preserved for exisitng data/metrics
var WTR_SPLIT_NAME = 'show_why_this_result_2';
// Prefix for all applicable conifgs
var WTR_CONFIG_MATCHER = 'why_this_result';
export var STATUS = {
    ERROR: 'error',
    LOADING: 'loading',
    LOADED: 'loaded',
    EMPTY: '',
};
// Exports sateful "Why This Result" content. Auto fetches generated description
// when feature flag enabled. Refresh method can be dispatched to retry API call.
// Content and status stay 'empty' if feature flag is disabled, and refresh
// method becomes no-op.
export var useWhyThisResult = function (setupConfig) {
    var _a = useState(false), isTreatementActive = _a[0], setIsTreatementActive = _a[1];
    var _b = useState(setupConfig.initialContent), whyThisResultContent = _b[0], setWhyThisResultContent = _b[1];
    var initialStatus = setupConfig.initialContent ? STATUS.LOADED : STATUS.EMPTY;
    var _c = useState(initialStatus), getContentStatus = _c[0], setGetContentStatus = _c[1];
    // Fetch split treatment, and intiate content fetch when enabled
    var setupWhyThisResultTreatment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var treatment, isActive;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTreatment(WTR_SPLIT_NAME, {
                        language: i18n.resolvedLanguage || 'en-US',
                        bestCareType: setupConfig.bestCareType || '',
                    })];
                case 1:
                    treatment = _a.sent();
                    if (typeof treatment !== 'string') {
                        console.error("error fetching 'why this result' treatment: treatment ".concat(treatment, " was of unknown type: \"").concat(typeof treatment, "\""));
                        return [2 /*return*/];
                    }
                    isActive = treatment.includes(WTR_CONFIG_MATCHER);
                    setIsTreatementActive(isActive);
                    // If loading a prior convo with content already generated,
                    // (i.e. triageResponse.triageSummaryReason), no need to re-generate
                    if (!whyThisResultContent && isActive) {
                        getContent();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Calls API to fetch summary reason, triggering STATUS state updates
    var getContent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var contentResp;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setGetContentStatus(STATUS.LOADING);
                    return [4 /*yield*/, getTriageSummaryReason(setupConfig.conversationId)];
                case 1:
                    contentResp = _c.sent();
                    if (!contentResp ||
                        contentResp.error ||
                        ((_a = contentResp.data) === null || _a === void 0 ? void 0 : _a.error) ||
                        !((_b = contentResp.data) === null || _b === void 0 ? void 0 : _b.triageSummaryReason)) {
                        setGetContentStatus(STATUS.ERROR);
                        return [2 /*return*/];
                    }
                    setWhyThisResultContent(contentResp.data.triageSummaryReason);
                    setGetContentStatus(STATUS.LOADED);
                    return [2 /*return*/];
            }
        });
    }); };
    var refreshState = function () {
        // No-op if flag is disabled or mis-configured
        if (isTreatementActive) {
            getContent();
        }
    };
    // Init on load
    useEffect(function () {
        setupWhyThisResultTreatment();
    }, []);
    return [
        { isActive: isTreatementActive, status: getContentStatus, content: whyThisResultContent },
        refreshState,
    ];
};
